import React from 'react';
import { motion } from 'framer-motion';

export default function SectionBlock({ section, onClick }) {
  return (
    <motion.div 
      whileHover={{ y: -12, scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
      className="group glass-card-light rounded-[2.5rem] overflow-hidden transition-all duration-500 cursor-pointer relative flex flex-col h-full"
      onClick={() => onClick(section.id)}
    >
      <div className="aspect-[16/10] overflow-hidden grayscale group-hover:grayscale-0 transition-all duration-700 relative">
        <img 
          src={section.image} 
          alt={section.title} 
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
        />
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-500" />
      </div>

      <div className="p-8 relative z-10 flex flex-col flex-grow">
        <h3 className="text-2xl font-black text-white mb-3 uppercase tracking-tighter [text-shadow:_0_2px_8px_rgba(0,0,0,0.8)]">
          {section.title}
        </h3>
        {/* Descripción: Ahora color blanco para máxima legibilidad */}
        <p className="text-white text-sm leading-relaxed mb-8 font-medium [text-shadow:_0_1px_4px_rgba(0,0,0,0.8)]">
          {section.description}
        </p>

        {/* Botón Explorar: Nuevo diseño Botón Rojo */}
        <div className="mt-auto flex justify-end">
          <div className="bg-red-600 px-6 py-2.5 rounded-full text-white font-bold text-xs transition-all duration-300 group-hover:bg-red-500 group-hover:scale-105 shadow-lg shadow-red-600/20">
            Explorar
          </div>
        </div>
      </div>
    </motion.div>
  );
}